import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { VariantTitlesCell } from "../components/common/VariantTitlesCell";
export var VARIANT_TITLES_COLUMN_WIDTH = "12%";
export var useVariantTitlesColumn = function () {
    var formatMessage = useIntl().formatMessage;
    return useMemo(function () { return ({
        name: formatMessage({
            id: "ui-br-legaldeposits.titles.variantTitles.label",
        }),
        key: "variantTitles",
        cellRenderer: function (item) {
            var _a;
            return (React.createElement(VariantTitlesCell, { variants: (_a = item.variantTitles) !== null && _a !== void 0 ? _a : undefined }));
        },
    }); }, [formatMessage]);
};
